import { actionWithDatapoint } from 'owa-analytics-actions';

// Toolbox expansion
export const collapseToolbox = actionWithDatapoint(
    'OUTLOOKSPACES_COLLAPSE_TOOLBAR',
    () => ({}),
    () => ({ options: { isCore: true } })
);
export const expandToolbox = actionWithDatapoint(
    'OUTLOOKSPACES_EXPAND_TOOLBAR',
    () => ({}),
    () => ({ options: { isCore: true } })
);
